import axios, { AxiosRequestConfig } from 'axios';
import type { CitationDeQuestion, NoteCommentDto, NoteCommentsPayload } from '../types/api';

const createConfig = (accessToken: string): AxiosRequestConfig => ({
    headers: {
        'Authorization': `Bearer ${accessToken}`,
        'AccessToken': accessToken,
        'Content-Type': 'application/json',
    },
});

const base = (noteId: string) => `/api/notes/${encodeURIComponent(noteId)}/comments`;

/**
 * Client de `notes/{noteId}/comments` (chantier C10, SP1) — discussion
 * « sous la note ». Les erreurs remontent à l'appelant (les thunks les
 * traduisent en état `failed` ; un 403/404 porte le message du serveur).
 */
export const noteCommentsService = {
    list: async (noteId: string, accessToken: string): Promise<NoteCommentsPayload> => {
        const response = await axios.get(base(noteId), createConfig(accessToken));
        return response.data.data;
    },
    /** Avec `citation`, le commentaire est une QUESTION sur un mot (C23 SP3) : 400 si le passage n'est pas dans la note, 409 si déjà posée. */
    create: async (noteId: string, input: { text: string; parentId?: string | null; citation?: CitationDeQuestion }, accessToken: string): Promise<NoteCommentDto> => {
        const body: Record<string, unknown> = { text: input.text, parentId: input.parentId ?? null };
        if (input.citation) body.citation = input.citation;
        const response = await axios.post(base(noteId), body, createConfig(accessToken));
        return response.data.data;
    },
    update: async (noteId: string, commentId: string, text: string, accessToken: string): Promise<NoteCommentDto> => {
        const response = await axios.put(`${base(noteId)}/${encodeURIComponent(commentId)}`, { text }, createConfig(accessToken));
        return response.data.data;
    },
    remove: async (noteId: string, commentId: string, accessToken: string): Promise<void> => {
        await axios.delete(`${base(noteId)}/${encodeURIComponent(commentId)}`, createConfig(accessToken));
    },
};

export default noteCommentsService;
